module.exports = __webpack_public_path__ + "i18n/de.5faa82a9ccc75472d05c175397ffd87c.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/de.json
// module id = 1056
// module chunks = 60